import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardHeader, Col, Row, Form } from 'reactstrap';
import InputGroup from '../../../components/cms/form/inputGroup';
import SubmitButtons from '../../../components/cms/form/submitButtons';
import MlFields from '../../../components/cms/form/mlFields';

const twoCols = { xs: 12, md: 6 };
const threeCols = { xs: 12, md: 4 };

const License = ({
  t,
  onChange,
  onSubmit,
  errors,
  formData,
  title,
  isSubmitting,
  isSubmittingRedirect,
  onChangeMl,
  types,
  statuses,
}) => (
  <div>
    <Row>
      <Col md={12}>
        <Card>
          <CardHeader>
            <strong><i className="fa fa-star pr-2" />{title}</strong>
          </CardHeader>
          <CardBody>
            <Row>
              <Col {...twoCols}>
                <InputGroup
                  name="type"
                  type="select"
                  label={t('Type')}
                  onChange={onChange}
                  errors={errors}
                  options={types}
                  value={formData.type}
                  icon="fa fa-link"
                />
              </Col>
              <Col {...twoCols}>
                <InputGroup
                  name="status"
                  type="select"
                  label={t('Status')}
                  onChange={onChange}
                  errors={errors}
                  options={statuses}
                  value={formData.status}
                  icon="fa fa-link"
                />
              </Col>
            </Row>

            <Form onSubmit={onSubmit(true)}>
              <MlFields
                onChange={onChangeMl}
                formData={formData}
                fields={props => (
                  <div>
                    <InputGroup
                      name="name"
                      label={t('Name')}
                      errors={errors}
                      onChange={props.onChange}
                      formData={props.formData}
                      icon="fa fa-file-text-o"
                    />
                    <InputGroup
                      name="description"
                      label={t('Description')}
                      errors={errors}
                      onChange={props.onChange}
                      formData={props.formData}
                      icon="fa fa-file-text-o"
                    />
                  </div>
                )}
              />
              <Row>
                <Col {...threeCols}>
                  <InputGroup
                    name="price_monthly"
                    label={t('Monthly price')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.price_monthly}
                    icon="fa fa-money"
                  />
                </Col>
                <Col {...threeCols}>
                  <InputGroup
                    name="price_yearly"
                    label={t('Yearly price')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.price_yearly}
                    icon="fa fa-money"
                  />
                </Col>
                <Col {...threeCols}>
                  <InputGroup
                    name="price_single"
                    label={t('Price single')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.price_single}
                    icon="fa fa-money"
                  />
                </Col>
              </Row>
              <Row>
                <Col {...threeCols}>
                  <InputGroup
                    name="token_value"
                    label={t('Token value')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.token_value}
                    icon="fa fa-key"
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <SubmitButtons
                    isSubmitting={isSubmitting}
                    onSubmit={onSubmit}
                    isSubmittingRedirect={isSubmittingRedirect}
                  />
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
);

License.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isSubmittingRedirect: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  onChangeMl: PropTypes.func.isRequired,
  types: PropTypes.array.isRequired,
};

export default License;



// WEBPACK FOOTER //
// ./src/views/licenses/license/License.jsx